import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { api } from '../lib/api'

function inferWebFormFactor() {
  if (typeof window === 'undefined') return 'DESKTOP'
  try {
    if (window.matchMedia('(max-width: 768px)').matches) return 'MOBILE'
  } catch {
    /* ignore */
  }
  const ua = navigator.userAgent || ''
  if (/Mobi|Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)) return 'MOBILE'
  return 'DESKTOP'
}

/** 모바일 웹일 때만 OS 힌트(선택). 데스크톱 웹은 null. */
function inferWebMobileOs(formFactor) {
  if (formFactor !== 'MOBILE') return null
  const ua = navigator.userAgent || ''
  if (/iPhone|iPad|iPod/i.test(ua)) return 'IOS'
  if (/Android/i.test(ua)) return 'ANDROID'
  return null
}

/**
 * 로그인 상태에서 웹 라우트 전환 시 페이지뷰를 서버에 기록한다(운영 활용도 집계용).
 */
export default function WebPageviewCollector() {
  const location = useLocation()
  const lastSentRef = useRef('')
  const timerRef = useRef(null)

  useEffect(() => {
    const token = typeof window !== 'undefined' ? localStorage.getItem('accessToken') : null
    if (!token) return undefined

    const path = `${location.pathname}${location.search || ''}`
    if (!path || path === lastSentRef.current) return undefined

    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      lastSentRef.current = path
      const formFactor = inferWebFormFactor()
      api
        .post('/analytics/web/pageviews', {
          route: path,
          clientSurface: 'WEB',
          formFactor,
          mobileOs: inferWebMobileOs(formFactor),
        })
        .catch(() => {})
    }, 600)

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [location.pathname, location.search])

  return null
}
